import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAssistantPage } from "app/shared/ai/AssistantLayoutContext";
import AutomationEditorPage from "./AutomationEditorPage";
import AutomationsIndex from "./AutomationsIndex";

const ASSISTANT_QUICK_ACTIONS = [
    "Crear alerta de temperatura",
    "Mantener la temperatura en rango",
    "Crear un límite de seguridad",
];

// Vista Automatizaciones: la lista y los editores de todos los tipos bajo una sola ruta (/automations/rules/*). Las rutas
// van anidadas aquí y no en mainRoutes por dos razones: el contexto de Xpit Assistant se arma una sola vez (la lista y
// cada editor lo completan con setAssistantContext), y buildRoutes de Jumbo muta los `children` de las rutas.
const AutomationsPage = () => {
    const location = useLocation();
    const [assistantContext, setAssistantContext] = useState({ mode: "list" });
    const inEditor = location.pathname !== "/automations/rules" && location.pathname !== "/automations/rules/";

    const assistantPage = useMemo(() => ({
        context: { page: "automatizaciones", ...assistantContext },
        quickActions: ASSISTANT_QUICK_ACTIONS,
        bottomOffset: inEditor ? 104 : 96,
    }), [assistantContext, inEditor]);

    useAssistantPage(assistantPage);

    return (
        <Box sx={{ width: "100%", maxWidth: 1360, mx: "auto" }}>
            <Routes>
                <Route index element={<AutomationsIndex setAssistantContext={setAssistantContext} />} />
                <Route path="new/:type" element={<AutomationEditorPage setAssistantContext={setAssistantContext} />} />
                <Route path=":type/:id" element={<AutomationEditorPage setAssistantContext={setAssistantContext} />} />
                <Route path="*" element={<Navigate to="/automations/rules" replace />} />
            </Routes>
        </Box>
    );
};

export default AutomationsPage;
